/** Allowed values for solo quiz list and PvP lobby room list (must match API validation). */
export const SOLO_PVP_LOBBY_PAGE_SIZE_OPTIONS = [12, 21] as const;

export const SOLO_PVP_LOBBY_DEFAULT_PAGE_SIZE = 12;
